const dateFormat = 'YYYY-MM-DD';
const dateFormatEU = 'DD-MM-YYYY';
const timeFormat = 'HH:mm:ss';

export default {
    config: {
        default: {
            locale: "en",
            dateFormat: dateFormatEU
        },
        format: {
            date: dateFormat,
            dateEU: dateFormatEU,
            time: timeFormat,
            dateTime: `${dateFormat} ${timeFormat}`,
            dateTimeEU: `${dateFormatEU} ${timeFormat}`,
            full: 'LLLL'
        }
    }
};
